import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as Tools from "../../helpers/Tools";
import { logUI } from '../../api/andyliticsApi';
import * as types from "../../constants/actionTypes";
import * as FileSaver from 'file-saver';

/**
 * Container component for the Payment Options page.
 * 
 */
class PaymentOptions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader: true,
            isCobraMember: false
        };

        this.handleFormDownload = this.handleFormDownload.bind(this);
        this.downloadForm = this.downloadForm.bind(this);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.PaymentOptions.ComponentDidMount", new Date(), Tools.getURLPath());
        this.componentDidUpdate(this.props);
    }

    componentDidUpdate(prevProps) {
        const { hpIdentity, isFetching, swhp } = this.props;

        if ((swhp || hpIdentity) && !isFetching && this.state.showLoader) {
            this.setState({
                showLoader: false,
                isCobraMember: hpIdentity && hpIdentity.roles.includes("CobraMembers") ? true : false
            });
        }

        if (this.props.form !== prevProps.form || this.props.error !== prevProps.error) {
            this.handleFormDownload();
        }
    }

    downloadForm(name) {
        this.props.getForm(name);
    }

    handleFormDownload() {
        if (this.props.error || !this.props.form || this.props.form.status === 204) {
            console.log("could not download form");
            return;
        }

        FileSaver.saveAs(this.props.form, "Automatic Payments Auth Form.pdf");
    }

    render() {
        return (
            <div className="container-fluid body-content hp">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="hp-title">
                            Payment Options
                                </div>
                    </div>
                    <hr className="full-width"></hr>
                    <div className="col-12 maxWidth-content">
                        <div className="paymentoptions-wrapper">
                            <div className="paymentoptions-container">
                                {this.state.showLoader ?
                                    <div id="claim-detail-spinner" className="spinner">
                                        <div className="bounce1" />
                                        <div className="bounce2" />
                                        <div className="bounce3" />
                                    </div>
                                    :
                                    <div>
                                        <div className="alt-background">
                                            <div className="payonline-container">
                                                <div className="row semi-bold-text payonline-title">
                                                    <div className="col-12 col-sm-8">
                                                        Quickly and easily submit your payments online
                                                    </div>
                                                    {this.state.isCobraMember ?
                                                        ""
                                                        :
                                                        <div className="col-12 col-sm-4">
                                                            <span className="btn" onClick={() => this.props.ssoInvoicesandPayments()}>Pay Online</span>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row paymentoptions-detail">
                                            <div className="col-12 col-sm-4">
                                                <div>
                                                    <span className="link-text col-head-icon"><span className="icon-call"></span></span>
                                                    <div className="bold-text"> Pay by Phone</div>
                                                </div>
                                                <hr></hr>
                                                <div>
                                                    HMO, SeniorCare (Cost) and SeniorCare Advantage HMO plan members
                                            </div>
                                                <div>
                                                    <span className="bold-text">Call:</span> 1.844.722.6251
                                            </div>
                                                <br />
                                                <div>
                                                    PPO, EPO, Vital Trasitions and SeniorCare Advantage PPO plan members
                                            </div>
                                                <div>
                                                    <span className="bold-text">Call:</span> 1.844.722.6252
                                            </div>
                                            </div>
                                            <div className="col-12 col-sm-4">
                                                <div>
                                                    <span className="link-text col-head-icon"><span className="icon-messages"></span></span>
                                                    <div className="bold-text"> Pay by Mail</div>
                                                </div>
                                                <hr></hr>
                                                <div>
                                                    Baylor Scott & White Health Plan <br />
                                                    P.O. Box 847473 <br />
                                                    Dallas, TX 75284-74-73
                                            </div>
                                                <br />
                                                <div>
                                                    Include your contract number on your payment so we can properly credit your account.
                                            </div>
                                            </div>
                                            <div className="col-12 col-sm-4">
                                                <div>
                                                    <span className="link-text col-head-icon"><span className="icon-clock"></span></span>
                                                    <div className="bold-text"> Automatic Payments</div>
                                                </div>
                                                <hr></hr>
                                                <div>
                                                    Mail the relevant authorization form below with a voided check to:
                                            </div>
                                                <br />
                                                <div>
                                                    Account Receivable <br />
                                                    Baylor Scott & White Health Plan <br />
                                                    1206 West Campus Drive <br />
                                                    Temple, TX 76502
                                            </div>
                                                {this.props.swhp ? "" :
                                                    <div>
                                                        <br />
                                                        <div>
                                                            <span className="link-text download-pointer" onClick={() => this.downloadForm("CommericalAutoPaymentForm")}><span className="icon-download status-document"></span>Commercial Members</span>
                                                        </div>
                                                        <br />
                                                        <div>
                                                            <span className="link-text download-pointer" onClick={() => this.downloadForm("MedicareAutoPaymentForm")}><span className="icon-download status-document"></span>Medicare Members</span>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

const mapStateToProps = (state, ownProps) => {
    return {
        error: state.healthPlanServices.error,
        form: state.healthPlanServices.form,
        isFetching: state.healthPlanServices.isFetching,
        hpIdentity: state.session.healthPlanUserProfile,
        swhp: state.domain.hi,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        ssoInvoicesandPayments: () => dispatch({ type: types.HP_SSO_INVOICESANDPAYMENTS_START }),
        getForm: (formName) => dispatch({ type: types.HP_GET_FORM_START, formName: formName })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PaymentOptions));
